/**
 * Creates a bound search function over the provided documents.
 * Prefer this over the former module-level initSearchIndex + searchPhrase pair
 * so that no shared mutable state exists between call sites.
 */
export function createSearchIndex(documents) {
    return function searchPhrase(phrase) {
        var _a, _b;
        function getFieldSearchResult(field, document) {
            const fieldValue = document[field];
            if (typeof fieldValue !== 'string') {
                return;
            }
            const startIndex = fieldValue.search(phrase);
            if (startIndex < 0) {
                return;
            }
            return {
                field, phrase, startIndex, phraseLength: phrase.length, document,
            };
        }
        const result = { items: [] };
        for (const doc of documents) {
            const searchResultItem = (_b = (_a = getFieldSearchResult('content', doc)) !== null && _a !== void 0 ? _a : getFieldSearchResult('releaseName', doc)) !== null && _b !== void 0 ? _b : getFieldSearchResult('releaseDate', doc);
            if (searchResultItem) {
                result.items.push(searchResultItem);
            }
        }
        return result;
    };
}
